import { createApp } from 'vue';
import './assets/css/index.css';
import App from './App.vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import { router, setI18nLocale } from './router/router.js';
import { createI18n } from 'vue-i18n';
import fr from './locales/fr.json';
import en from './locales/en.json';
import { setI18nInstance } from './stores/locale';

const i18n = createI18n({
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    fr,
    en,
  },
});

// Donner l'instance i18n au store locale pour synchronisation immédiate
setI18nInstance(i18n);

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(i18n);
app.use(PrimeVue, {
  unstyled: true,
});
app.use(ToastService);
app.use(router);
app.component('Select', Select);
app.component('MultiSelect', MultiSelect);

setI18nLocale(i18n);

app.mount('#app');
